export const logoNegative = [
  "608 134",
  `
  <title>coreui react pro logo</title>
`,
];
